import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import classNames from 'classnames'
import { HomepageBannerContent } from '../../redux-toolkits/home-page/homePage.type'
import Icon from '../icon'

export const HomePageMarketingBanner = ({
  item,
  id,
  sortable = false,
  className = '',
  onRemove,
}: {
  item: HomepageBannerContent
  id: string
  sortable?: boolean
  className?: string
  onRemove?: () => void
}) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  }

  return (
    <div
      className={classNames(
        'relative w-full flex flex-col bg-frost',
        className,
      )}
      ref={setNodeRef}
      style={style}
    >
      <img
        src={item?.desktopImage}
        className="block w-full aspect-square max-h-[192px] object-cover rounded-md"
        alt={`product`}
      />

      <p className="line-clamp-1 mt-2 text-black text-base font-medium">
        {item?.heading}
      </p>

      {item?.subtext && (
        <p className="line-clamp-3 mt-0.5 text-sec-black text-sm">{`${item?.subtext}`}</p>
      )}

      {id && sortable ? (
        <div className="flex w-full items-end justify-center flex-1">
          <button
            className="w-fit cursor-grab mx-auto mt-4 !max-w-[50px]"
            {...attributes}
            {...listeners}
            type="button"
          >
            <Icon id="rearrange" width={24} height={24} />
          </button>
        </div>
      ) : undefined}

      {onRemove && (
        <button
          className={classNames(
            'p-2 bg-gray-bg rounded-full w-fit absolute top-4 right-4',
          )}
          type="button"
          onClick={(e) => {
            e.stopPropagation()
            onRemove()
          }}
        >
          <Icon className="text-danger" width={20} height={20} id="bin" />
        </button>
      )}
    </div>
  )
}
